import React from 'react';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { controlType, ApprovedStatus } from '../../constants/common';
import { allocationConfig, overTimeColumnList, employeeConfig, employeeSuperVisorOvertimeColumn } from '../../constants/MockData';
import { apiBatchRequest, apiDelete, apiPost, apiPut, apiRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import GridTable from '../common/Table/Table';
import { Tooltip, IconButton, TableCell, TextField, Table, TableHead, TableRow, TableBody } from '@material-ui/core';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  cloneDeep,
  applyFilterOnData,
  UpdateColumnWithConfiguration,
  isGridFormValid,
  isDateInCurrentPayCycle,
  isDateInPreviousPayCycle,
  getCurrentPayCycleStartDate,
  isDateInNextPayCycle,
  IsSectionVisible,
  removeDuplicates,
  numberWithCommas
} from '../../utils/helper';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import _ from 'lodash';
import { marketRequiredField, propertyRequiredField, DateFormat, propertyDisabledField, SECTIONS, Operators } from '../../constants/appConstants';
import Visibility from '@material-ui/icons/Visibility';
import store from '../../store/appStore';
import { getFormattedValues } from '../../utils/formatData';

class OverTimeAttendance extends React.PureComponent {
  constructor(props) {
    super(props);
    // const groupName = (((((store.getState() || {}).user || {}).userData || {}).groups || [])[0] || {}).accessGroupName || '';
    // const roleBasedDefaultAllocationType = groupName === 'Property Accounting' ? 'Property' : 'Market';
    const aType = this.props.allocationType !== undefined ? this.props.allocationType[0]?.allocationType : 'Market';
    // if (groupName !== undefined || groupName !== null) {
    //   if (groupName.includes('Property')) {
    //     aType = 'Market';
    //   } else {
    //     aType = 'Property';
    //   }
    // }

    // : roleBasedDefaultAllocationType;
    this.state = {
      //   allocationData: [],
      //   departmentMasterData: [],
      employeeMasterData: [],
      propertyMasterData: [],
      //   propertyTypeMasterData: [],
      marketMasterData: [],
      configuration: [],
      selectedData: [],
      defaultSelectedData: [],
      selectedEmployeeId: this.props.selectedEmployeeId,
      allocationType: aType,
      selectedAllocationType: aType,
      selectedPropertyId: this.props.selectedPropertyId,
      renderAsChild: this.props.renderAsChild,
      marketId: this.props.marketId,
      selectedEditRowId: undefined,
      isInAddMode: false,
      mode: '',
      updateData: {
        allocationId: 0,
        cloudOrgId: 0,
        userEmail: '',
        propertyId: 0,
        employeeId: 0,
        roleId: 0,
        allocationStartDate: '',
        allocationEndDate: '',
        billingStartDate: '',
        billingEndDate: '',
        marketAllocationPercent: 0,
        // marketBillingPercent: 0,
        propertyAllocationPercent: 0,
        propertyBillingPercent: 0,
        additionalFixedAmount: 0,
        rateValue: 0,
        isReimbursed: false,
        isApproved: true,
        allocationType: '',
        statusId: 0,
        marketId: 0,
        isAllocatedToLegalEntity: false,
        legalEntityId: 0,
        legalEntityAndPropertyData: null,
        previousIsAllocatedToLegalEntity: false,
        approvalId: 0,
        marketName: '',
        propertyName: ''
      },
      isPopupOpen: false,
      confirmationMessage: '',
      rowIndex: 0,
      allocationColumns: (overTimeColumnList),
      isPreviousToCurrentOrFuture: false,
      postRecord: [],
      isDelete: false,
      previousEditRecord: {},
      isEditableMode: false,
      statusMasterData: [],
      isSave: false,
      isUpdate: false
    };
  }

  childParameter = (OnlyActiveAllocation = false) => {
    let atype = this.state?.selectedAllocationType;
    if (atype === undefined || atype === '') {
      if (this.props.allocationType !== undefined) {
        atype = this.props.allocationType;
      } else {
        const groupName = (((((store.getState() || {}).user || {}).userData || {}).groups || [])[0] || {}).accessGroupName || '';
        // const roleBasedDefaultAllocationType = groupName === 'Property Accounting' ? 'Property' : 'Market';
        const roleBasedDefaultAllocationType = groupName.includes('Property') ? 'Property' : 'Market';
        if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION) && roleBasedDefaultAllocationType === 'Market') {
          atype = 'Market';
        } else if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION) && roleBasedDefaultAllocationType === 'Property') {
          atype = 'Property';
        }
      }
    }

    let query = '?OnlyActiveAllocation=' + !OnlyActiveAllocation + '&allocationType=' + (atype || '') + '&';
    // let query = '?';

    if (this.props.renderAsChild) {
      if (this.props.selectedEmployeeId !== undefined) {
        query = query + 'EmployeeId=' + (this.props.selectedEmployeeId || '0') + '&';
      }
      if (this.props.marketId !== undefined && this.props.marketId !== null && this.props.marketId !== '') {
        const allocationType = this.props.allocationType[0]?.allocationType;
        if (allocationType !== 'Property') {
          query = query + 'MarketId=' + (this.props.marketId || '0') + '&';
        }
      }
      if (this.props.selectedPropertyId !== undefined && this.props.selectedPropertyId !== null && this.props.selectedPropertyId !== '') {
        query = query + 'PropertyId=' + (this.props.selectedPropertyId || '0') + '&';
      }
      if (this.props.selectedPropertyId !== undefined && this.props.selectedPropertyId !== null && this.props.selectedPropertyId !== '') {
        query = query + 'PropertyId=' + (this.props.selectedPropertyId || '0') + '&';
      }
    }
    return query;
  }

  getCurrentPayCycle() {
    const date = [];
    const currentMonthStartDate = moment()
      .startOf('month')
      .format('MM/DD/YYYY');

    const currentMonthMidDate = moment(currentMonthStartDate, 'MM/DD/YYYY').add(
      14,
      'days'
    );
    const currentMonthLastDate = moment().endOf('month').format('MM/DD/YYYY');
    if (
      moment().format('MM/DD/YYYY') >= currentMonthStartDate &&
      moment().format('MM/DD/YYYY') <= currentMonthMidDate.format('MM/DD/YYYY')
    ) {
      date.push(currentMonthStartDate);
      date.unshift(currentMonthMidDate.format('MM/DD/YYYY'));
    } else {
      date.push(currentMonthLastDate);
      const currentMonthMidDate1 = moment(currentMonthMidDate, 'MM/DD/YYYY').add(
        1,
        'days'
      );
      date.push(currentMonthMidDate1.format('MM/DD/YYYY'));
    }
    return date;
  }

  componentDidMount() {
    const date = this.getCurrentPayCycle();
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeListBySupervisor,
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 10
      },
      {
        url: API_URL.Property.GetPropertyList + '?listType=1',
        key: 'propertyMasterData'
      },
      //   {
      //     url: API_URL.Allocation.GetApprovalStatus,
      //     key: 'statusMasterData',
      //     duration: 60
      //   },
      {
        url: API_URL.Report.GetPayCycle,
        key: 'lstDateRange'
      },
      {
        url: API_URL.Employee.GetPendingEmployeeOvertimeDetail,
        key: 'employeeOvertimeData'
      },
      {
        url: API_URL.Employee.GetEmployeeListBySupervisor,
        key: 'empoyeeListBySupervisor'
      },
      {
        url: API_URL.Market.GetAllMarketMasterdata,
        key: 'marketMasterDataAll'
      }
    ])
      .then(
        ({
          employeeOvertimeData,
          //   allocationData,
          employeeMasterData,
          //   departmentMasterData,
          //   propertyTypeMasterData,
          marketMasterData,
          propertyMasterData,
          //   statusMasterData,
          lstDateRange,
          empoyeeListBySupervisor,
          marketMasterDataAll
        }) => {
          this._asyncRequest = null;
          if (employeeOvertimeData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          const selectedData = [];
          const serviceTypeId = 0;
          const serviceType = '';
          const allocationType = '';
          console.log(marketMasterDataAll);

          //   if (this.props.renderAsChild && this.props.selectedEmployeeId !== undefined) {
          //     allocationType = this.props.allocationType[0]?.allocationType;
          //     if (allocationType === 'Property') {
          //       serviceTypeId = (employeeMasterData.data.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).serviceTypeId;
          //       serviceType = (employeeMasterData.data.find(x => x.employeeId === this.props.selectedEmployeeId) || {}).serviceType;
          //     }
          //   }

          // if (this.props.selectedEmployeeId !== undefined) {
          //   selectedData.push({
          //     key: 'onlyActiveAllocation',
          //     selected: [{ onlyActiveAllocation: false }]
          //   });
          // }
          if (this.props.renderAsChild && allocationType !== 'Property' && this.props.marketId !== undefined && this.props.marketId !== null && this.props.marketId !== '') {
            selectedData.push({
              key: 'marketName',
              selected: (marketMasterData.data || []).filter(
                (x) => x.marketId === parseInt(this.props.marketId)
              )
            });
          }
          const selectedAllocationType = '';
          if (this.props.selectedPropertyId !== undefined) {
            selectedData.push({
              key: 'propertyName',
              selected: (propertyMasterData.data || []).filter(
                (x) => x.propertyId === parseInt(this.props.selectedPropertyId)
              )
            });
          }
          if (this.props.selectedEmployeeId !== undefined) {
            selectedData.push({
              key: 'employeeName',
              selected: (employeeMasterData.data || []).filter(
                (x) => x.employeeId === parseInt(this.props.selectedEmployeeId)
              )
            });
          }
          // this.GetAllocationFromServer(selectedData, true);
          selectedData.push({
            key: 'payCycle',
            selected: (lstDateRange.data.find(x => x.payCycle === (date[1] + '-' + date[0])) || {})
          });
          this.setState({
            employeeOvertimeData: employeeOvertimeData.data,
            responseEmployeeOvertimeData: employeeOvertimeData.data,
            dateRangeNext: lstDateRange.data,
            // statusMasterData: statusMasterData.data || [],
            // responseAllocationData: allocationData.data || [],
            configuration: employeeOvertimeData.config,
            // allocationData: applyFilterOnData(
            //   allocationData.data || [],
            //   selectedData
            // ),
            defaultSelectedData: cloneDeep(selectedData),
            employeeMasterData: (this.props.selectedEmployeeId !== undefined && this.props.selectedEmployeeId > 0) ? employeeMasterData.data.filter(x => x.employeeId === this.props.selectedEmployeeId) : employeeMasterData.data || [],
            // departmentMasterData: departmentMasterData.data || [],
            // propertyTypeMasterData: propertyTypeMasterData.data || [],
            marketMasterData: this.props.marketId !== undefined && this.props.marketId !== null && this.props.marketId !== '' && this.props.renderAsChild && serviceType !== 'Property Accounting'
              ? (marketMasterData.data || []).filter(
                (x) => x.marketId === parseInt(this.props.marketId)
              )
              : marketMasterData.data || [],
            filterPropertyMasterData: propertyMasterData.data || [],
            selectedData: selectedData || [],
            selectedAllocationType,
            empoyeeListBySupervisor: empoyeeListBySupervisor.data
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  onFilterChange = (selectedData) => {
    const { responseEmployeeOvertimeData } = this.state;
    const filteredData = applyFilterOnData(_.cloneDeep([...responseEmployeeOvertimeData]), selectedData);
    this.setState({
      employeeOvertimeData: filteredData, selectedData
    });
  };

  static getDerivedStateFromProps(newpros, state) {
    if (JSON.stringify(newpros.allocationType && newpros.allocationType[0].allocationType) !==
      JSON.stringify(state.allocationType) ||
      newpros.selectedEmployeeId !== state.selectedEmployeeId ||
      newpros.renderAsChild !== state.renderAsChild
    ) {
      const selectedData = [];

      if (newpros.marketId !== undefined) {
        selectedData.push({
          key: 'marketName',
          selected: (state.marketMasterData.data || []).filter(
            (x) => x.marketId === parseInt(state.marketId)
          )
        });
      }
      if (newpros.allocationType !== undefined) {
        selectedData.push({
          key: 'allocationType',
          selected: newpros.allocationType
        });
      }
      if (newpros.selectedPropertyId !== undefined) {
        selectedData.push({
          key: 'propertyName',
          selected: (state.propertyMasterData || []).filter(
            (x) => x.propertyId === parseInt(newpros.selectedPropertyId)
          )
        });
      }
      if (newpros.selectedEmployeeId !== undefined) {
        selectedData.push({
          key: 'employeeName',
          selected: (state.employeeMasterData || []).filter(
            (x) => x.employeeId === parseInt(newpros.selectedEmployeeId)
          )
        });
      }
      let stateToBeUpdated = {};
      if (JSON.stringify(newpros.allocationType && newpros.allocationType[0].allocationType) !==
        JSON.stringify(state.allocationType)) {
        stateToBeUpdated = {
          selectedEditRowId: undefined,
          isInAddMode: false,
          updateData: {
            allocationId: 0,
            cloudOrgId: 0,
            userEmail: '',
            propertyId: 0,
            employeeId: 0,
            roleId: 0,
            allocationStartDate: '',
            allocationEndDate: '',
            billingStartDate: '',
            billingEndDate: '',
            marketAllocationPercent: 0,
            // marketBillingPercent: 0,
            propertyAllocationPercent: 0,
            propertyBillingPercent: 0,
            additionalFixedAmount: 0,
            rateValue: 0,
            isReimbursed: false,
            isApproved: true,
            allocationType: '',
            statusId: 0,
            marketId: 0,
            isAllocatedToLegalEntity: false,
            legalEntityId: 0,
            legalEntityAndPropertyData: null,
            previousIsAllocatedToLegalEntity: false,
            approvalId: 0,
            marketName: '',
            propertyName: ''
          }
        };
      }
      return {
        ...stateToBeUpdated,
        allocationType: newpros.allocationType && newpros.allocationType[0].allocationType,
        selectedAllocationType: newpros.allocationType && newpros.allocationType[0].allocationType,
        renderAsChild: newpros.renderAsChild,
        marketId: newpros.marketId,
        selectedEmployeeId: newpros.selectedEmployeeId,
        selectedPropertyId: newpros.selectedPropertyId,
        selectedData: selectedData,
        defaultSelectedData: cloneDeep(selectedData)
        // allocationData: applyFilterOnData(
        //   state.responseAllocationData,
        //   selectedData
        // )
      };
    }
    return null;
  }

  componentWillUnmount() {
    if (this._asyncRequest) {
      // this._asyncRequest.cancel();
    }
  }

  EditRecordOne = (cellInfo, mode = 'Edit') => {
    console.log(cellInfo, mode);
    const { postRecord } = this.state;
    let msg = '';
    if (mode === 'Edit') {
      msg = 'Do you want to approve this record.';
      postRecord.push(cellInfo);
    } else if (mode === 'Delete') {
      msg = 'Do you want to delete this record';
      postRecord.push(cellInfo);
    } else if (mode === 'Reject') {
      msg = 'Do you want to reject this record';
      postRecord.push(cellInfo);
    }
    this.setState({
      isPopupOpen: true,
      confirmationMessage: msg,
      mode,
      postRecord
    });
  }

  renderActionColumn = (cellInfo, key, isInAddMode, index) => {
    const showAdd = false;
    return (
      <>
        {this.state.selectedEditRowId !== undefined && cellInfo.allocationId === this.state.selectedEditRowId.value
          ? (
            <>
            </>
          )
          : (
            <>

              <Tooltip title="Approve Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                      ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                      return false;
                    } else {
                      this.EditRecordOne(cellInfo);
                    }
                  }}
                >
                  <CheckCircleRoundedIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Reject Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.EditRecordOne(cellInfo, 'Reject');
                  }}
                >
                  <CancelRoundedIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.EditRecordOne(cellInfo, 'Delete');
                  }}
                >
                  <DeleteIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>

            </>)}
      </>
    );
  };

  updateOvertimeEmployee(postRecord, mode) {
    apiPut(API_URL.Employee.SaveEmployeeOvertime, [...postRecord], { mode }).then(({ data: response }) => {
      if (response.success === true) {
        console.log(response);
        ShowToast(
          mode === 'Edit' ? 'OverTime Employee approved successfully' : 'Overtime Employee deleted successfully',
          toastType.SUCCESS,
          5000,
          500
        );
      } else {
        ShowToast(
          response.msg,
          toastType.error,
          5000,
          500
        );
      }
    }).catch(() => {
      ShowToast(
        commonLabels.somethingWrong,
        toastType.ERROR,
        false,
        500
      );
    });
  }

  loadPendingOverTimeData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetPendingEmployeeOvertimeDetail,
        key: 'employeeOvertimeData'
      }
    ])
      .then(({ employeeOvertimeData }) => {
        this.setState({
          responseEmployeeOvertimeData: employeeOvertimeData.data || [],
          configuration: employeeOvertimeData.config,
          employeeOvertimeData: applyFilterOnData(
            employeeOvertimeData.data || [],
            this.state.selectedData
          )
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  onPopupClickHandle = (value) => {
    const { selectedEditRowId, postRecord, isDelete, mode } = this.state;
    if (value) {
      if (mode === 'Edit') {
        postRecord.forEach(x => {
          x.approvalStatusId = 4;
          x.statusId = 1;
          if (x.otDate === null) {
            x.otDate = x.otDay;
          }
        });
        this.updateOvertimeEmployee(postRecord, mode);
      } else if (mode === 'Delete') {
        postRecord.forEach(x => {
          x.statusId = 11;
          if (x.otDate === null) {
            x.otDate = x.otDay;
          }
        });

        this.updateOvertimeEmployee(postRecord, mode);
      } else if (mode === 'Reject') {
        postRecord.forEach(x => {
          x.statusId = 1;
          x.approvalStatusId = 9;
          if (x.otDate === null) {
            x.otDate = x.otDay;
          }
        });
        this.updateOvertimeEmployee(postRecord, mode);
      }

      this.setState({ isPopupOpen: false, confirmationMessage: '', mode: '', postRecord: [] });
      this.loadPendingOverTimeData();
    } else {
      this.setState({ isPopupOpen: false, confirmationMessage: '', mode: '', postRecord: [] });
    }
  }

  render() {
    const {
      dateRangeNext,
      employeeMasterData,
      propertyMasterData,
      filterPropertyMasterData,
      //   propertyTypeMasterData,
      //   departmentMasterData,
      marketMasterData,
      configuration,
      selectedData,
      updateData,
      isPopupOpen,
      confirmationMessage,
      allocationColumns
      //   statusMasterData
    } = this.state;
    // console.log(allocationColumns);

    const hiddenConfig = [];
    const EditSource = [];
    EditSource.push(
      { key: 'employeeMasterData', data: (employeeMasterData || []).filter(x => x.employeeStatus === true) },
      { key: 'marketMasterData', data: marketMasterData },
      //   { key: 'departmentMasterData', data: departmentMasterData },
      { key: 'propertyMasterData', data: propertyMasterData }
    );
    const filterConfigRef = [
      {
        multiple: true,
        type: controlType.DropDown,
        source: marketMasterData,
        key: 'marketName',
        placeholder: 'Search Market',
        title: 'Market'
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: filterPropertyMasterData,
        key: 'propertyName',
        placeholder: 'Search Property',
        title: 'Property Name',
        hidewhen: { key: 'allocationType', value: 'Market' },
        allowreset: !((this.props.renderAsChild === true &&
          this.props.selectedPropertyId !== undefined)),
        hideFilter: ((this.props.renderAsChild === true &&
          ((this.props.allocationType || [])[0] || {}).allocationType !== 'Property'))
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: employeeMasterData,
        key: 'employeeName',
        placeholder: 'Search Employee',
        title: 'Employee',
        allowreset: !((this.props.renderAsChild === true &&
          this.props.selectedEmployeeId !== undefined)),
        ignoreFilters: ['propertyTypeName', 'propertyName', 'departmentName', 'marketName']
      },
      {
        multiple: false,
        type: controlType.DropDown,
        source: dateRangeNext,
        key: 'payCycle',
        placeholder: 'Pay Period',
        title: 'Pay Period',
        ignoreSort: true,
        disableClearable: true
      }
    ];
    const filterConfig = [
      ...filterConfigRef
    ];

    return (
      <>
        {isPopupOpen && (
          <ConfirmDialog
            IsOpen={isPopupOpen}
            Message={confirmationMessage}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onPopupClickHandle(isValid);
              } else {
                this.onPopupClickHandle(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          />
        )}
        {this.props.renderAsChild !== true && (
          <PageHeader title="Pending Overtime Attendance List"></PageHeader>
        )}
        {(this.props.clientId === null || this.props.clientId === 0) && (<label style={{ fontWeight: '700', marginLeft: '25px', color: 'red' }} > Property {this.props.propertyName} does not have any active PTF or Services. Employee Allocations can be done after a PTF is created for the Property.</label>)
        }
        <PageFilter
          autoFilter={false}
          filterAlwaysVisible={this.props.renderAsChild !== true}
          onFilterChanged={this.onFilterChange}
          filterConfig={filterConfig}
          defaultSelectedData={this.state.defaultSelectedData}
          selectedData={selectedData}
          gridColumn={3}
          hidePanel={true}
        ></PageFilter>
        <div className="row table-list-container">
          {/* { this.state.employeeOvertimeData.length > 0 ?  */}
          <GridTable
            columns={UpdateColumnWithConfiguration(
              employeeSuperVisorOvertimeColumn,
              configuration || [],
              hiddenConfig || []
            )}
            data={this.state.employeeOvertimeData || []}
            config={employeeConfig}
            renderActionColumn={this.renderActionColumn}
            selectedEditRowId={this.state.selectedEditRowId}
            isInAddMode={this.state.isInAddMode}
            EditSource={EditSource}
            // handleTableEditChange={this.handleTableEditChange}
            updateData={updateData}
            // AddNewRecord={{
            //   action: this.AddNewRecord,
            //   title: 'Add New Overtime',
            //   visible: showAdd
            // }}
            rowBadge={{
              key: 'allocationId',
              equalsTo: 2,
              class: 'message rotate-badge',
              title: 'New'
            }}
            // renderDynamicForm={this.renderDynamicForm}
            isEditableMode={this.state.isEditableMode}
            reload={this.state.reloadtable}
          ></GridTable>
          {/* : 'No records found' */}
          {/* } */}
        </div>
      </>
    );
  }
}

export default OverTimeAttendance;
